/*

Sainapse® incorporates patented, and “patent pending”, technology.

© 2017 - 2024 Sainapse Inc. and its licensors. All rights reserved worldwide.

Sainapse Inc. and its licensors own all rights in this work, including but not limited to the source code, algorithms, text, 
flowcharts and images herein, which are protected by copyright laws in applicable jurisdictions. Any use of this work is permissible 
only with an express written license or authorization from Sainapse Inc., and only to the extent and for the purpose permitted. 
Unauthorized copying, editing, reproduction, redistribution, modification, creation of derivative works, translation, adaptation, 
customization, decompilation, reverse engineering, disassembling or hacking of this work or any part thereof, including but not limited to the source code, 
header files and libraries of the software, via any medium is strictly prohibited.

Open Source Software that is provided as part of Sainapse® is subject to and governed solely by the terms and conditions of the applicable open source license agreements, 
and their respective terms, conditions, restrictions and obligations, a copy of which will be made available to you upon request.

Proprietary and Confidential. Sainapse® and associated documentation is the property of Sainapse Inc. and considered confidential information. 
No part of it may be disclosed without the express written consent of Sainapse Inc.Please note that any infringement or violation will invite legal action, 
both civil and criminal, as appropriate, without any further notice.

*/
import React from "react";

let excelToReactStyleDirectMap = {
  background_color: "backgroundColor",
  // border: "border",
  height: "height",
  width: "width",
};

let excelToReactStyleInDirectMap = {
  font_color: "",
  bold: "",
  wrap: "",
  italic: "",
  align: "",
  border_botton: "",
  border_Left: "",
  border_top: "",
  border_right: "",
};

function convertToReactStyles(excelStyle, reactStyleObject) {
  for (let excelStyleKey in excelStyle) {
    if (excelStyleKey in excelToReactStyleDirectMap) {
      reactStyleObject[excelToReactStyleDirectMap[excelStyleKey]] =
        excelStyle[excelStyleKey];
    } else if (excelStyleKey in excelToReactStyleInDirectMap) {
      //case bold
      if (excelStyleKey == "bold" && excelStyle[excelStyleKey] == true) {
        reactStyleObject["fontWeight"] = "bold";
      }

      //case italic
      if (excelStyleKey == "italic" && excelStyle[excelStyleKey] == true) {
        reactStyleObject["fontWeight"] = "italic";
      }

      //check align, general means left aligned
      if (excelStyleKey == "align") {
        if (excelStyle[excelStyleKey] == "GENERAL") {
          reactStyleObject["textAlign"] = "left";
        } else {
          reactStyleObject["textAlign"] = excelStyle[excelStyleKey];
        }
      }

      //case wrap
      if (excelStyleKey == "wrap" && excelStyle[excelStyleKey] == true) {
        reactStyleObject["wordWrap"] = "breakWord";
      }

      //top border
      if (
        excelStyleKey == "border_top" &&
        excelStyle[excelStyleKey] == "true"
      ) {
        let borderTopInfo = excelStyle[excelStyleKey];
        reactStyleObject["borderTopWidth"] = "2px";
        reactStyleObject["borderTopStyle"] = borderTopInfo.type || "solid";
        reactStyleObject["borderTopColor"] = borderTopInfo.color || "#217346";
      }

      //right border
      if (
        excelStyleKey == "border_right" &&
        excelStyle[excelStyleKey] == "true"
      ) {
        let borderRightInfo = excelStyle[excelStyleKey];
        reactStyleObject["borderRightWidth"] = "2px";
        reactStyleObject["borderRightStyle"] = borderRightInfo.type || "solid";
        reactStyleObject["borderRightColor"] =
          borderRightInfo.color || "#217346";
      }

      //bottom border
      if (
        excelStyleKey == "border_bottom" &&
        excelStyle[excelStyleKey] == "true"
      ) {
        let borderBottomInfo = excelStyle[excelStyleKey];
        reactStyleObject["borderBottomWidth"] = "2px";
        reactStyleObject["borderBottomStyle"] =
          borderBottomInfo.type || "solid";
        reactStyleObject["borderBottomColor"] =
          borderBottomInfo.color || "#217346";
      }
      //left border
      if (
        excelStyleKey == "border_left" &&
        excelStyle[excelStyleKey] == "true"
      ) {
        let borderLeftInfo = excelStyle[excelStyleKey];
        reactStyleObject["borderLeftWidth"] = "2px";
        reactStyleObject["borderLeftStyle"] = borderLeftInfo.type || "solid";
        reactStyleObject["borderLeftColor"] = borderLeftInfo.color || "#217346";
      }
      //font - color temporary processing from ARGB value we convert into #rgb
      // if (excelStyleKey == "font_color") {
      //   //we get 8 bytes ARGB,
      //   let argbColor = excelStyle[excelStyleKey];
      //   //take last six characters
      //   let rgbColor = argbColor.substring(2);
      //   //add "#" character infront
      //   rgbColor = "#" + rgbColor;
      //   reactStyleObject["color"] = rgbColor;
      // }
    }
  }
}

function convertToReactStylesHrzntl(
  excelStyle,
  isInActiveRow,
  isInActiveColumn,
  colIndex,
  rowIndex,
  headerRow,
  selectedDataCell
) {
  let reactStyleObject = {};

  convertToReactStyles(excelStyle, reactStyleObject);

  //special case for second row starting from colindx A
  if (rowIndex == 1 && headerRow == 1) {
    reactStyleObject["backgroundColor"] =
      reactStyleObject["backgroundColor"] || "#EDEBE9";
    reactStyleObject["color"] = reactStyleObject["color"] || "#000000";

    reactStyleObject["borderTopWidth"] = "1px";
    reactStyleObject["borderRightWidth"] = "1px";
    reactStyleObject["borderBottomWidth"] = "1px";
    reactStyleObject["borderLeftWidth"] = "1px";

    reactStyleObject["borderTopStyle"] = "solid";
    reactStyleObject["borderRightStyle"] = "solid";
    reactStyleObject["borderBottomStyle"] = "solid";
    reactStyleObject["borderLeftStyle"] = "solid";

    reactStyleObject["borderTopColor"] = "#D4D4D4";
    reactStyleObject["borderRightColor"] = "#D4D4D4";
    reactStyleObject["borderBottomColor"] = "#D4D4D4";
    reactStyleObject["borderLeftColor"] = "#D4D4D4";
  }

  if (
    selectedDataCell !== null &&
    colIndex == selectedDataCell.col_index &&
    rowIndex == selectedDataCell.row_index
  ) {
    reactStyleObject["borderTopWidth"] = "2px";
    reactStyleObject["borderRightWidth"] = "2px";
    reactStyleObject["borderBottomWidth"] = "2px";
    reactStyleObject["borderLeftWidth"] = "2px";

    reactStyleObject["borderTopStyle"] = "solid";
    reactStyleObject["borderRightStyle"] = "solid";
    reactStyleObject["borderBottomStyle"] = "solid";
    reactStyleObject["borderLeftStyle"] = "solid";

    reactStyleObject["borderTopColor"] = "#217346";
    reactStyleObject["borderRightColor"] = "#217346";
    reactStyleObject["borderBottomColor"] = "#217346";
    reactStyleObject["borderLeftColor"] = "#217346";
    // reactStyleObject["backgroundColor"] = "#c7c7c7";
  } else if (isInActiveRow) {
    //modify color backgorund of cell here
    //coor of sequence cell/rowno
    //row handling not working with table border collapse "sepearate" ihence this hack

    reactStyleObject["borderTopWidth"] = "1px";
    reactStyleObject["borderTopStyle"] = "solid";
    reactStyleObject["borderTopColor"] = "#217346";

    reactStyleObject["borderBottomWidth"] = "1px";
    reactStyleObject["borderBottomStyle"] = "solid";
    reactStyleObject["borderBottomColor"] = "#217346";

    if (colIndex == 0) {
      reactStyleObject["backgroundColor"] = "#def0e0";
      reactStyleObject["color"] = "#217346";
      reactStyleObject["fontWeight"] = "bold";

      reactStyleObject["borderLeftWidth"] = "1px";
      reactStyleObject["borderLeftStyle"] = "solid";
      reactStyleObject["borderLeftColor"] = "#217346";
    }
    //color of actual data cell
    else {
      reactStyleObject["backgroundColor"] = "#c7c7c7";
    }
  } else if (isInActiveColumn) {
    //modify color backgorund of cell here
    //coor of sequence cell/rowno
    //row handling not working with table border collapse "sepearate" ihence this hack

    reactStyleObject["borderLeftWidth"] = "1px";
    reactStyleObject["borderLeftStyle"] = "solid";
    reactStyleObject["borderLeftColor"] = "#217346";

    reactStyleObject["borderRightWidth"] = "1px";
    reactStyleObject["borderRightStyle"] = "solid";
    reactStyleObject["borderRightColor"] = "#217346";

    if (rowIndex == 0) {
      reactStyleObject["backgroundColor"] = "#def0e0";
      reactStyleObject["color"] = "#217346";
      reactStyleObject["fontWeight"] = "bold";

      reactStyleObject["borderTopWidth"] = "1px";
      reactStyleObject["borderTopStyle"] = "solid";
      reactStyleObject["borderTopColor"] = "#217346";
    }

    //color of actual data cell
    else {
      reactStyleObject["backgroundColor"] = "#c7c7c7";
    }
  }
  return reactStyleObject;
}

function computeHrzntlPositionAndZIndex(cellData, headerRow) {
  //3 cases
  let rowIndex = cellData.row_index;
  let colIndex = cellData.col_index;
  let styleObject = {};

  // //stickying
  if (rowIndex == 0 && colIndex == 0) {
    styleObject = { position: "sticky", left: "0", top: "0" };
  } else if (rowIndex == 1 && colIndex == 0) {
    styleObject = { position: "sticky", left: "0", top: "24px" };
  } else if (rowIndex == 0) {
    styleObject = {
      position: "sticky",
      top: "0",
    };
  } else if (rowIndex == 1 && headerRow == 1) {
    styleObject = {
      position: "sticky",
      top: "24px",
    };
  } else if (colIndex == 0) {
    styleObject = {
      position: "sticky",
      left: "0",
    };
  }

  //z-indexing

  if ((rowIndex == 0 && colIndex == 0) || (rowIndex == 1 && colIndex == 0)) {
    styleObject = { ...styleObject, zIndex: 5 };
  } else if (rowIndex == 0 || (rowIndex == 1 && headerRow == 1)) {
    styleObject = { ...styleObject, zIndex: 4 };
  } else if (colIndex == 0) {
    styleObject = { ...styleObject, zIndex: 3 };
  }

  return styleObject;
}

function convertToReactStylesVrtcl(
  excelStyle,
  isInActiveRow,
  isInActiveColumn,
  colIndex,
  rowIndex,
  headerColumn,
  selectedDataCell
) {
  let reactStyleObject = {};
  convertToReactStyles(excelStyle, reactStyleObject);
  //special case for second row starting from colindx A
  if (colIndex == "A" && headerColumn == "A") {
    reactStyleObject["backgroundColor"] =
      reactStyleObject["backgroundColor"] || "#EDEBE9";
    reactStyleObject["color"] = reactStyleObject["color"] || "#000000";
    reactStyleObject["borderTopWidth"] = "1px";
    reactStyleObject["borderRightWidth"] = "1px";
    reactStyleObject["borderBottomWidth"] = "1px";
    reactStyleObject["borderLeftWidth"] = "1px";

    reactStyleObject["borderTopStyle"] = "solid";
    reactStyleObject["borderRightStyle"] = "solid";
    reactStyleObject["borderBottomStyle"] = "solid";
    reactStyleObject["borderLeftStyle"] = "solid";

    reactStyleObject["borderTopColor"] = "#D4D4D4";
    reactStyleObject["borderRightColor"] = "#D4D4D4";
    reactStyleObject["borderBottomColor"] = "#D4D4D4";
    reactStyleObject["borderLeftColor"] = "#D4D4D4";
  }

  if (
    selectedDataCell !== null &&
    colIndex == selectedDataCell.col_index &&
    rowIndex == selectedDataCell.row_index
  ) {
    reactStyleObject["borderTopWidth"] = "2px";
    reactStyleObject["borderRightWidth"] = "2px";
    reactStyleObject["borderBottomWidth"] = "2px";
    reactStyleObject["borderLeftWidth"] = "2px";

    reactStyleObject["borderTopStyle"] = "solid";
    reactStyleObject["borderRightStyle"] = "solid";
    reactStyleObject["borderBottomStyle"] = "solid";
    reactStyleObject["borderLeftStyle"] = "solid";

    reactStyleObject["borderTopColor"] = "#217346";
    reactStyleObject["borderRightColor"] = "#217346";
    reactStyleObject["borderBottomColor"] = "#217346";
    reactStyleObject["borderLeftColor"] = "#217346";
    // reactStyleObject["backgroundColor"] = "#c7c7c7";
  } else if (isInActiveRow) {
    //modify color backgorund of cell here
    //coor of sequence cell/rowno
    //row handling not working with table border collapse "sepearate" ihence this hack
    reactStyleObject["borderTopWidth"] = "1px";
    reactStyleObject["borderTopStyle"] = "solid";
    reactStyleObject["borderTopColor"] = "#217346";

    reactStyleObject["borderBottomWidth"] = "1px";
    reactStyleObject["borderBottomStyle"] = "solid";
    reactStyleObject["borderBottomColor"] = "#217346";
    if (colIndex == 0) {
      reactStyleObject["backgroundColor"] = "#def0e0";
      reactStyleObject["color"] = "#217346";
      reactStyleObject["fontWeight"] = "bold";
      reactStyleObject["borderLeftWidth"] = "1px";
      reactStyleObject["borderLeftStyle"] = "solid";
      reactStyleObject["borderLeftColor"] = "#217346";
    }

    //color of actual data cell
    else {
      reactStyleObject["backgroundColor"] = "#c7c7c7";
    }
  } else if (isInActiveColumn) {
    //modify color backgorund of cell here
    //coor of sequence cell/rowno
    //row handling not working with table border collapse "sepearate" ihence this hack
    reactStyleObject["borderLeftWidth"] = "1px";
    reactStyleObject["borderLeftStyle"] = "solid";
    reactStyleObject["borderLeftColor"] = "#217346";

    reactStyleObject["borderRightWidth"] = "1px";
    reactStyleObject["borderRightStyle"] = "solid";
    reactStyleObject["borderRightColor"] = "#217346";

    if (rowIndex == 0) {
      reactStyleObject["backgroundColor"] = "#def0e0";
      reactStyleObject["color"] = "#217346";
      reactStyleObject["fontWeight"] = "bold";
      reactStyleObject["borderTopWidth"] = "1px";
      reactStyleObject["borderTopStyle"] = "solid";
      reactStyleObject["borderTopColor"] = "#217346";
    }

    //color of actual data cell
    else {
      reactStyleObject["backgroundColor"] = "#c7c7c7";
    }
  }
  return reactStyleObject;
}

function computeVrtclPositionAndZIndex(cellData, headerColumn) {
  let rowIndex = cellData.row_index;
  let colIndex = cellData.col_index;
  let styleObject = {};

  // //stickying
  if (rowIndex == 0 && colIndex == 0) {
    styleObject = { position: "sticky", left: "0", top: "0" };
  } else if (rowIndex == 1 && colIndex == 0) {
    styleObject = { position: "sticky", left: "0", top: "24px" };
  } else if (rowIndex == 0) {
    styleObject = {
      position: "sticky",
      top: "0",
    };
  } else if (colIndex == "A" && headerColumn == "A") {
    styleObject = {
      // position: "sticky",
      // //need to calculate dynmically.
      // left: "24px",
    };
  } else if (colIndex == 0) {
    styleObject = {
      position: "sticky",
      left: "0",
    };
  }

  //z-indexing

  if ((rowIndex == 0 && colIndex == 0) || (rowIndex == 0 && colIndex == "A")) {
    styleObject = { ...styleObject, zIndex: 5 };
  } else if (colIndex == 0 || (colIndex == "A" && headerColumn == "A")) {
    styleObject = { ...styleObject, zIndex: 4 };
  } else if (rowIndex == 0) {
    styleObject = { ...styleObject, zIndex: 3 };
  }

  return styleObject;
}

class Cell extends React.Component {
  constructor(props) {
    super(props);
  }

  render() {
    const {
      data,
      orientation,
      activeRowNo,
      activeColNo,
      activeCell,
      updateActiveColNo,
      isInActiveRow,
      isInActiveColumn,
      updateActiveRowNo,
      updateActiveCell,
      headerColumn,
      headerRow,
    } = this.props;

    function onclickHandler() {
      console.log(data.row_index, data.col_index);
      //if column index
      if (data.row_index == 0 && data.col_index == 0) {
        return;
      }

      //clicked on col index number, update active column
      if (data.row_index == 0) {
        console.log("udpate col no");
        updateActiveColNo(data.col_index);
        updateActiveRowNo(null);
        updateActiveCell(null);
      }
      //clicked on row sequence no, update active row no
      else if (data.col_index == 0) {
        console.log("update row no ");
        updateActiveRowNo(data.row_index);
        updateActiveColNo(null);
        updateActiveCell(null);
      }
      //if data cell
      else {
        updateActiveRowNo(null);
        updateActiveColNo(null);
        updateActiveCell(data);
      }
    }

    if (orientation === "horizontal") {
      return (
        <td
          style={{
            ...computeHrzntlPositionAndZIndex(data, headerRow),
            borderLeftWidth: "1px",
            borderLeftStyle: "solid",
            borderLeftColor: "#D4D4D4",
            borderTopWidth: "1px",
            borderTopStyle: "solid",
            borderTopColor: "#D4D4D4",
            borderRightWidth: "1px",
            borderRightStyle: "solid",
            borderRightColor: "#D4D4D4",
            borderBottomWidth: "1px",
            borderBottomStyle: "solid",
            borderBottomColor: "#D4D4D4",
            borderCollapse: "collapse",
            padding: "3px",
            fontSize: "11pt",
            // maxWidth: "40rem",
            // whiteSpace: "pre-wrap",
            cursor:
              data.col_index == 0 || data.row_index == 0 ? "pointer" : "cell",
            ...convertToReactStylesHrzntl(
              data.style,
              isInActiveRow,
              isInActiveColumn,
              data.col_index,
              data.row_index,
              headerRow,
              activeCell
            ),
          }}
          onClick={onclickHandler}
          colSpan={data.col_span || 1}
          rowSpan={data.row_span || 1}
        >
          {
            //special check for making first column second row value to empty
            data.col_index == 0 && data.row_index == 1 ? "1" : data.value
          }
        </td>
      );
    } else if (orientation === "vertical") {
      return (
        <td
          style={{
            ...computeVrtclPositionAndZIndex(data, headerColumn),
            borderLeftWidth: "1px",
            borderLeftStyle: "solid",
            borderLeftColor: "#D4D4D4",
            borderTopWidth: "1px",
            borderTopStyle: "solid",
            borderTopColor: "#D4D4D4",
            borderRightWidth: "1px",
            borderRightStyle: "solid",
            borderRightColor: "#D4D4D4",
            borderBottomWidth: "1px",
            borderBottomStyle: "solid",
            borderBottomColor: "#D4D4D4",
            borderCollapse: "collapse",
            padding: "3px",
            fontSize: "11pt",
            // maxWidth: "40rem",
            // whiteSpace: "pre-wrap",
            cursor:
              data.col_index == 0 || data.row_index == 0 || data.row_index == 1
                ? "pointer"
                : "cell",
            ...convertToReactStylesVrtcl(
              data.style,
              isInActiveRow,
              isInActiveColumn,
              data.col_index,
              data.row_index,
              headerColumn,
              activeCell
            ),
          }}
          onClick={onclickHandler}
          colSpan={data.col_span || 1}
          rowSpan={data.row_span || 1}
        >
          {
            //special check for making first column second row value to 1
            data.col_index == 0 && data.row_index == 1 ? "1" : data.value
          }
        </td>
      );
    }
  }
}

export default Cell;
